import React, { Component } from 'react';
// import congratsTextImgUrl from "../../style/images/lucky_winner.gif";
// import {tntI18n} from "../../services/DataService";
import RemitUtil from '@app/modules/Landing/Remittance/RemitUtil';
import { I18n } from './LangUtil';
import moment from 'moment';

const TickBox = (props) => (
  <div className={`item ${props.success ? 'success' : 'error'}`} style={props.style}>
      <span>
        <svg className="successIco" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" show={props.success.toString()} style={{width: props.width || ''}}>
          <circle className="path circle" fill="none" stroke="#73AF55" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <polyline className="path check" fill="none" stroke="#73AF55" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <svg className="errorIco" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" show={(!props.success).toString()} style={{width: props.width || ''}}>
          <circle className="path circle" fill="none" stroke="#D06079" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <line className="path line" fill="none" stroke="#D06079" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
          <line className="path line" fill="none" stroke="#D06079" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
      </span>
    <span>{props.label || ""}</span>
  </div>
);

const SwitchBtn = (props) => (
  <label className="toggle">
    <input className="tgl tgl-theme" type="checkbox" onChange={props.clickfun} checked={props.value} />
    <span className="tgl-btn"/>
  </label>
);

const BlockedDialog = props => (
  <div dangerouslySetInnerHTML={{__html : I18n(`g.msg.account_block`)}} />
);

class Counter extends Component {
  state = {
    number: 0
  };
  componentDidMount(){
    this.nextNum = this.props.num;
    this.nextNumber();
  }
  nextNumber(){
    if(isNaN(this.nextNum)) {
      this.setState({ number:this.nextNum });
      return;
    }
    if(isNaN(this.state.number)){
      this.setState({ number: 0 });
    }
    let delta = this.nextNum - this.state.number;
    if(delta === 0) return;
    let increasing = delta > 0;
    let absDelta = increasing ? delta : delta * (-1);
    let increment = absDelta > 100 ? Math.floor(delta / 100) : (increasing ? 1 : -1);
    let stopCondition;
    let int = window.setInterval(() => {
      this.setState(prevState => {
        stopCondition = increasing ? prevState.number >= Math.floor(this.nextNum) : prevState.number <= Math.ceil(this.nextNum);
        if(stopCondition){
          window.clearInterval(int);
          return {
            number: this.nextNum
          }
        }
        return {
          number: Math.ceil(prevState.number) + increment
        };
      });
    }, 8);
  }

  componentWillReceiveProps(newProps){
    this.nextNum = newProps.num;
    this.nextNumber();
  }

  render(){
    return isNaN(this.state.number) ? (
      `${this.state.number}`
    ) : (
      this.props.commaSeparated ? `${RemitUtil.numberWithCommas(this.state.number)}` : this.state.number

    )
  }
}

class ProgressArc extends Component {
  constructor(){
    super();
  }
  static defaultProps = {
    size: 100,
    strokeWidth: 10,
    stroke: '#fff',
    counterClockwise: 'false',
    background: null
  }

  render() {
    var size = parseInt(this.props.size),
      strokeWidth = parseInt(this.props.strokeWidth),
      stroke = this.props.stroke,
      counterClockwise = this.props.counterClockwise,
      background = this.props.background,
      complete = parseFloat(this.props.complete),
      offset = /firefox/i.test(navigator.userAgent) ? -89.9 : -90,
      strokeWidthCapped = Math.min(strokeWidth, size / 2 - 1),
      radius = Math.max((size - strokeWidthCapped) / 2 - 1, 0),
      circumference = 2 * Math.PI * radius,
      backgroundElement,
      transform = 'rotate(' + offset + ', ' + size / 2 + ', ' + size / 2 + ')';

    if (background !== null) {
      backgroundElement = React.createElement('circle', {
        fill: 'none',
        cx: (size / 2) + 'px',
        cy: (size / 2) + 'px',
        r: radius + 'px',
        stroke: background,
        strokeWidth: strokeWidthCapped
      });
    }

    if (counterClockwise && counterClockwise != 'false') {
      transform += ' translate(0, ' + size + ') scale(1, -1)';
    }

    return (
      React.createElement('svg', {width: size + 'px', height: size + 'px', style: {width: `${size}px`, height: `${size}px`, margin:0}},
        backgroundElement,
        React.createElement('circle', {
          fill: 'none',
          cx: (size / 2) + 'px',
          cy: (size / 2) + 'px',
          r: radius + 'px',
          stroke: stroke,
          strokeWidth: strokeWidthCapped,
          strokeDasharray: circumference,
          style: {
            strokeDashoffset: ((1 - complete) * circumference),
            stroke: stroke,
            transition: 'stroke-dashoffset 0.1s linear'
          },
          transform: transform
        })
      )
    );
  }
}


const VoucherImg = props => (
    <div className="voucher-container" style={{
      textAlign: 'center',
      margin: "0 auto",
      padding: "100px 0 0",
      width: 770
    }}>
      {/* <img src={congratsTextImgUrl} style={{margin: '-25px 0 10px 0'}} alt=""/> */}
      <br/>
      {/* <h5 style={{fontSize: '19px', marginTop: '-10px'}}>{tntI18n(`remittance.promotion.${props.prizeKey}.message`)}</h5> */}
      <br/>
      {(()=>{
        try{
          // return <img src={require(`@app/style/images/${props.prizeKey}.jpg`)} alt="" />
        } catch(e){
          console.error(e);
          return props.alt || " ";
        }
      })()}
      <h3> Keep transacting online to win more </h3>
      {/* <h6 style={{fontSize: '17px', marginTop: '5px'}}>Kindly contact  <span className="svgicons svgicons-call"></span> {tntI18n("remittance.promotion.phone")} to claim prize</h6> */}
      <hr style={{margin: "17px auto 0", width: "60%"}}/>
    </div>
)

const RenderTime = ({ remainingTime }) => {
  return (
    <div className="timer">
      <div className="value">{remainingTime}</div>
      <div className="text">seconds</div>
    </div>
  );
};
const RenderTimeInMS = ({ remainingTime }) => {
  return (
    <div className="timer">
      <div className="value">{`${Math.floor(remainingTime / 60)}:${(remainingTime % 60).toString().padStart(2, '0')}`}</div>
    </div>
  );
};

export {SwitchBtn, TickBox, Counter, BlockedDialog, ProgressArc, VoucherImg, RenderTime, RenderTimeInMS};
